import { Form, InputNumber } from '@maxtropy/components';
import { Space } from 'antd';
import { ColumnsType } from 'antd/es/table';
export interface BillItem {
  id: string | number;
  name: string;
  unit?: string;
  isParent?: boolean;
  isChild?: boolean;
  parentId?: string | number;
  amount?: string | number;
  quantity?: number;
  computedAmount?: string | number;
}
export const dataSource: BillItem[] = [
  { id: 'capacityAndDemandFee', name: '容需量电费', isParent: true, unit: 'kW' },
  { id: 'residential', name: '居民电费', isParent: true, unit: 'kWh' },
  { id: 'catalog1', name: '目录电费', parentId: 'residential', isChild: true },
  { id: 'fund1', name: '政府性基金及附加', parentId: 'residential', isChild: true },
  { id: 'commercial', name: '工商业电费', isParent: true, unit: 'kWh' },
  { id: 'retail', name: '零售交易电费', parentId: 'commercial', isChild: true },
  { id: 'loss', name: '上网环节线损费用', parentId: 'commercial', isChild: true },
  { id: 'transmission', name: '输配电费', parentId: 'commercial', isChild: true },
  { id: 'system', name: '系统运行费', parentId: 'commercial', isChild: true },
  { id: 'fund2', name: '政府性基金及附加', parentId: 'commercial', isChild: true },
  { id: 'powerFactor', name: '功率因数调整电费', isParent: true },
  { id: 'market', name: '市场化电费', isParent: true },
];

export const Sum = (values: (string | number | undefined)[]): string => {
  const nums = values.map(v => parseFloat(String(v))).filter(v => !isNaN(v));
  return nums.length > 0 ? nums.reduce((a, b) => a + b, 0).toFixed(2) : '-';
};

export const getNumberRules = (prop: string, required?: boolean) => [
  { required: required ?? true, message: '请输入' },
  {
    pattern: /^-?\d+(\.\d{1,2})?$/,
    message: '请输入有效的数字，最多保留2位小数',
  },
  {
    validator: (_: any, value: any) => {
      if (!value) return Promise.resolve();
      const num = parseFloat(value);
      if (prop === 'small') {
        if (isNaN(num) || num < 0.0 || num > 99999999.99) {
          return Promise.reject('请输入0.00~99999999.99之间的数字');
        }
      } else {
        if (isNaN(num) || num < -99999999.99 || num > 99999999.99) {
          return Promise.reject('请输入-99999999.99~99999999.99之间的数字');
        }
      }

      return Promise.resolve();
    },
  },
];

export const getBillContentColumns = ({
  isView,
  dataSource,
}: {
  isView: boolean;
  dataSource: BillItem[];
}): ColumnsType<BillItem> => [
  {
    title: '费用组成',
    dataIndex: 'name',
    render: (_, record) => (
      <>
        <span style={{ color: '#ff4d4f', marginRight: 4, paddingLeft: record.isChild ? 24 : 0 }}>*</span>
        <span
          style={{
            fontWeight: record.isParent ? 600 : 'normal',
            color: '#bebdbdff',
          }}
        >
          {record.name}
        </span>
      </>
    ),
    width: 220,
  },
  {
    title: '计收数量',
    dataIndex: 'quantity',
    render: (_, record, index) => {
      if (
        dataSource
          .filter(item => item.isParent)
          .slice(0, 3)
          .some(p => p.id === record.id)
      ) {
        return (
          <Form.Item
            name={['billContent', index, 'quantity']}
            rules={getNumberRules('big')}
            style={{ marginBottom: 0 }}
          >
            <Space>
              <InputNumber placeholder="请输入" disabled={isView} />
              {record.unit && <span>{record.unit}</span>}
            </Space>
          </Form.Item>
        );
      }
    },
    width: 180,
  },
  {
    title: '电费',
    dataIndex: 'amount',
    render: (_, record, index) => {
      if (dataSource.filter(item => item.parentId).some(item => item.parentId === record.id)) {
        return <span>{record.computedAmount}元</span>;
      }

      return (
        <Form.Item name={['billContent', index, 'amount']} rules={getNumberRules('big')} style={{ marginBottom: 0 }}>
          <Space>
            <InputNumber placeholder="请输入" disabled={isView} />元
          </Space>
        </Form.Item>
      );
    },
    width: 180,
  },
];
